<template lang="pug">
#app
  .background-gradient
  .container
    nav-navbar
    transition(name="fade" mode="out-in")
      router-view

  nav-footer
  script(
    type="application/ld+json"
    v-text="json")
</template>

<script>
import navNavbar from '@/components/Navbar'
import navFooter from '@/components/Footer'

export default {
  name: 'app',
  components: { navNavbar, navFooter },
  computed: {
    json () {
      let obj = []

      let p = this.$store.state.jsonLD
      p.website.url = window.location.origin
      p.organization.url = window.location.origin
      p.organization.logo = window.location.origin + '/static/logo.png'
      for (var key in p) {
        if (p.hasOwnProperty(key)) {
          obj.push(p[key])
        }
      }
      return obj
    }
  },
  watch: {
    '$store.state.meta.title': function (to, from) {
      let theDefault = this.$store.state.meta.defaults.title

      document.title = to.replace(/\b\w/g, l => l.toUpperCase()) || theDefault
      document.querySelector('meta[property="og:title"]')
        .setAttribute('content', to.replace(/\b\w/g, l => l.toUpperCase()) || theDefault)
    },
    '$store.state.meta.description': function (to, from) {
      let theDefault = this.$store.state.meta.defaults.description

      document.querySelector('meta[name=description]')
        .setAttribute('content', to || theDefault)
      document.querySelector('meta[property="og:description"]')
        .setAttribute('content', to || theDefault)
    },
    '$store.state.meta.keywords': function (to, from) {
      document.querySelector('meta[name=keywords]')
        .setAttribute('content', this.$store.state.meta.keywords || this.$store.state.meta.defaults.keywords)
    },
    '$route': function (to, from) {
      // start with basic meta tags
      let url = window.location.href
      let amp = 'https://amp.navlegalnotaries.com' + window.location.pathname

      document.querySelector('link[rel=canonical]')
        .setAttribute('href', url)
      document.querySelector('link[rel=amphtml]')
        .setAttribute('href', amp)
      document.querySelector('meta[property="og:url"]')
        .setAttribute('content', url)

      let org = this.$store.state.jsonLD.organization

      org.contactPoint = [{
        '@type': 'ContactPoint',
        'telephone': '+1-800-813-6084',
        'contactType': 'customer service'
      }]

      // clear old breadcrumbs
      let bread = this.$store.state.jsonLD.breadcrumbs
      bread.itemListElement = []
      let position = bread.itemListElement.length

      // auto incrementing breadcrumb builder
      class BreadCrumb {
        constructor (location, name) {
          this['@type'] = 'ListItem'
          this.position = ++position
          this.item = {
            '@id': window.location.origin + location,
            'name': name
          }
        }
      }

      // $route getter and formatter
      let routeHelper = this.$route
      function route (stringOne, stringTwo = null, prettyPrint = false) {
        let val = stringTwo ? routeHelper[stringOne][stringTwo] : routeHelper[stringOne]
        return prettyPrint ? val.replace(/_/g, ' ').replace(/,/g, '.') : val
      }

      bread.itemListElement.push(
        new BreadCrumb('/index.html', 'NavLegal'))

      // no more breadcrumbs if on homepage
      if (route('name') === 'Home') {
        return
      }

      if (!route('params', 'province')) {
        // [services, about, contact, all notaries]
        bread.itemListElement.push(
          new BreadCrumb(
            route('path'),
            route('name')))
      } else {
        // allNotaries > ProvincialPage
        bread.itemListElement.push(
          new BreadCrumb(
            '/notaries/',
            'Notaries'),
          new BreadCrumb(
            '/notaries/' + route('params', 'province'),
            route('params', 'province', true).replace(/_/g, ' ').replace(/,/g, '.').replace(/\b\w/g, l => l.toUpperCase())))

        if (route('params', 'city')) {
          // > City page
          bread.itemListElement.push(
            new BreadCrumb(
              '/notaries/' + route('params', 'province') + '/' + route('params', 'city'),
              route('params', 'city', true).replace(/_/g, ' ').replace(/,/g, '.').replace(/\b\w/g, l => l.toUpperCase())))
        }
      }
    }
  }
}
</script>

<style lang="scss">
body {
  background: #fff;
  overflow-x: hidden;
}

#app {
  color: #333;
  font-family: 'Open Sans', sans-serif;
  // position: relative;
  overflow-y: hidden;
  &:before {
    background: linear-gradient(45deg, #f00, #fff);
    opacity: 0.05;
    content: '';
    position: absolute;
    z-index: -1;
    transform: rotate(-25deg);
    border-radius: 50%/200px 200px 100px 10px;
    top: 50%;
    bottom: 25%;
    left: -25%;
    right: -25%;
  }
  &:after {
    background: linear-gradient(45deg, #f00, #fff);
    opacity: 0.05;
    content: '';
    position: absolute;
    z-index: -1;
    transform: rotate(-12deg);
    border-radius: 50%/200px 200px 100px 10px;
    top: 75%;
    bottom: -1%;
    left: -25%;
    right: -25%;
  }
}

.container {
  max-width: 1170px;
  margin: 0 auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.red {
  color: #f00;
}

.phone {
  white-space: nowrap;
}

html,
body {
  // height: 100%;
  font-size: 16px;
  margin: 0;
  padding: 0;
}

h1 {
  margin: 0;
}


// .columns {
//   margin: 15px 0 !important;
// }
</style>



// WEBPACK FOOTER //
// App.vue?2fe83aaf